import { Injectable } from '@angular/core'
import { Observable } from 'rxjs/Observable'
import { Subject } from 'rxjs/Subject'
import { Response } from '@angular/http'

@Injectable()
export class AppHttpBroadcaster {
  private errorsSource: Subject<Response>
  private errorsObservable: Observable<Response>

  constructor() {
    this.errorsSource  = new Subject<Response>()
    this.errorsObservable = this.errorsSource.asObservable()
  }

  emitError(response: Response): void {
    this.errorsSource.next(response)
  }

  errors(): Observable<Response> {
    return this.errorsObservable
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./app/core/http/app-http.broadcaster.ts